import React from "react";
import PropTypes from "prop-types";
import { Button, Text } from "@fluentui/react-components";
import { FormattedMessage } from "react-intl";
import { Modal } from "../modal/Modal";

export const RSVPErrorDialog = ({ onClose, errorMessage, message, reason }) => {
  // Function to get appropriate title based on reason
  const getTitle = () => {
    if (reason === "duplicate_booking") {
      return <FormattedMessage id="rsvp-error.duplicate.title" defaultMessage="Already Registered" />;
    }
    if (reason === "reservation_expired") {
      return <FormattedMessage id="rsvp-error.expired.title" defaultMessage="Reservation Expired" />;
    }
    if (reason === "payment_not_complete") {
      return <FormattedMessage id="rsvp-error.payment-incomplete.title" defaultMessage="Payment Incomplete" />;
    }
    return <FormattedMessage id="rsvp-error.title" defaultMessage="Registration Failed" />;
  };

  // Function to get appropriate message based on reason or message
  const getErrorMessage = () => {
    if (message) {
      return message.replace(/\+/g, " "); // Decode URL encoding
    }

    if (reason === "duplicate_booking") {
      return "You are already registered for this activation!";
    }
    if (reason === "reservation_expired") {
      return "Your reservation has expired. Please try again.";
    }
    if (reason === "booking_failed_after_payment") {
      return "Booking failed after payment";
    }
    if (reason === "payment_not_complete") {
      return "The payment process was not completed. Please try again.";
    }
    if (reason === "missing_session") {
      return "Your payment session was not found or expired. Please try again.";
    }
    if (reason === "verification_failed") {
      return "We were unable to verify your payment. Please try again.";
    }
    if (reason === "internal_error") {
      return "There was an error processing your request. Please try again. If the problem persists, please contact support.";
    }
    if (reason === "payment_verification_failed") {
      return "A server error occurred during payment verification. Please try again.";
    }

    return errorMessage || "We are sorry, but something went wrong. Please try again.";
  };

  return (
    <Modal
      title={getTitle()}
      onClose={onClose}
      actions={
        <Button appearance="primary" onClick={onClose}>
          <FormattedMessage id="rsvp-error.close" defaultMessage="Close" />
        </Button>
      }
    >
      <Text>{getErrorMessage()}</Text>
    </Modal>
  );
};

RSVPErrorDialog.propTypes = {
  onClose: PropTypes.func,
  errorMessage: PropTypes.string,
  message: PropTypes.string,
  reason: PropTypes.string
};

export default RSVPErrorDialog;
